import { render } from "./DocumentCreateEditModal.vue?vue&type=template&id=5c1ff8be"
import script from "./DocumentCreateEditModal.vue?vue&type=script&lang=js"
export * from "./DocumentCreateEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__